import React from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import TuneIcon from "@mui/icons-material/Tune";

export default function SearchInput({
  value,
  onChange,
  setSearch,
  onAdvancedSearchClick,
}) {
  const handleClear = () => {
    onChange("");
    setSearch("");
  };

  return (
    <TextField
      value={value || ""}
      onChange={v => onChange(v.target.value)}
      placeholder="Search"
      inputProps={{
        "data-id": "search-input",
      }}
      size="small"
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value && (
              <IconButton onClick={handleClear}>
                <CloseIcon />
              </IconButton>
            )}
            {onAdvancedSearchClick && (
              <>
                <Box sx={{ width: "1px", height: 24, bgcolor: "divider", mx: 0.5 }} />
                <Tooltip arrow title="Advanced Search">
                  <IconButton onClick={onAdvancedSearchClick}>
                    <TuneIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
            <IconButton type="submit">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
